import React from "react";
import { FaShip, FaUsers, FaHeart, FaHome } from "react-icons/fa"; // Import icons

export default function Services() {
  return (
    <>
      {/* Top Service Icons */}
      <div
        className="rts-secvice-area-solaric-banner-bottom start rts-section-gapBottom"
        id="services-top"
      >
        <div className="container">
          <div className="row g-4">
            {/* Cruise Vacation */}
            <div className="col-lg-3 col-md-6 col-12">
              <div className="single-service-solari">
                <div className="icon-area service-icon">
                  <FaShip />
                </div>
                <h5 className="title">Cruise Vacation</h5>
                <p className="disc">
                  Crafting innovative blueprints and detailed plans tailored to
                  client needs.
                </p>
              </div>
            </div>

            {/* Group Tour */}
            <div className="col-lg-3 col-md-6 col-12">
              <div className="single-service-solari">
                <div className="icon-area service-icon two">
                  <FaUsers />
                </div>
                <h5 className="title">Group Tour</h5>
                <p className="disc">
                  Clearing, grading, and preparing sites for construction
                  projects.
                </p>
              </div>
            </div>

            {/* Honeymoon Package */}
            <div className="col-lg-3 col-md-6 col-12">
              <div className="single-service-solari">
                <div className="icon-area service-icon three">
                  <FaHeart />
                </div>
                <h5 className="title">Honeymoon Package</h5>
                <p className="disc">
                  Laying the groundwork for sturdy, stable structures.
                </p>
              </div>
            </div>

            {/* Family Package */}
            <div className="col-lg-3 col-md-6 col-12">
              <div className="single-service-solari">
                <div className="icon-area service-icon four">
                  <FaHome />
                </div>
                <h5 className="title">Family Package</h5>
                <p className="disc">
                  Building robust frameworks and erecting durable buildings.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
